<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
        @batchImport="batchImport"
      />
      <pagination
        size="mini"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <BatchImport ref="batchImport" @reload="reload" />
  </div>
</template>
<script>
import { VXETable } from 'vxe-table'
import BaseTable from '@/mixins/base-table'
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BatchImport from '../batch-import'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, BatchImport },
  data() {
    return {
      usePage: true,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .purchaseMaterialListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'purchase-materialPurchase-detail',
        params: { ...params, pageType },
        query,
      })
    },
    async batchImport() {
      const types = ['xls', 'XLS', 'xlsx', 'XLSX']
      const { file } = await VXETable.readFile({ types }).catch(() => ({}))
      if (!file) return

      this.$refs.batchImport.open({ file })
    },
  },
}
</script>
